import Enum from './enum'

class LotState extends Enum
{
  constructor(value) {
    super(value);
  }
}

LotState.init({
  DRAFT: 'Draft',
  APPROVING: 'Approving',
  APPROVED: 'Approved',
  DECLINED: 'Declined',
  IN_TENDER: 'InTender',
  APPROVED_TENDER: 'ApprovedTender',
  WAITING_FOR_REQUESTS: 'GettingReq',
  WAITING_FOR_OPENING_PROTOCOL: 'WaitingGettingReqProtocol',
  PROCESSING_REQUESTS: 'ProcessingReq',
  ESTIMATING_REQUESTS: 'EstimatingReq',
  CREATING_RETEND: 'CreatingRetend',
  WAITING_FOR_RETEND: 'WaitingRetend',
  WAITING_FOR_RESOLUTION: 'WaitingResolution',
  PROCESSING_RETEND: "ProcessingRetend",
  RETEND: 'Retend',
  DIVIDING_PRICE: 'DividingPrice',
  WINNER: 'Winner',
  CLOSED: 'Closed',
  CANCELLED: 'Cancelled'
}, {
  DRAFT: 'lot-state.draft',
  APPROVING: 'lot-state.approving',
  APPROVED: 'lot-state.approved',
  DECLINED: 'lot-state.declined',
  IN_TENDER: 'lot-state.in-tender',
  APPROVED_TENDER: 'lot-state.approved-tender',
  WAITING_FOR_REQUESTS: 'lot-state.waiting-for-requests',
  WAITING_FOR_OPENING_PROTOCOL: 'lot-state.waiting-for-opening-protocol',
  PROCESSING_REQUESTS: 'lot-state.processing-requests',
  ESTIMATING_REQUESTS: 'lot-state.estimating-requests',
  CREATING_RETEND: 'lot-state.creating-retend',
  WAITING_FOR_RETEND: 'lot-state.waiting-for-retend',
  WAITING_FOR_RESOLUTION: 'lot-state.waiting-for-resolution',
  PROCESSING_RETEND: 'lot-state.processing-retend',
  RETEND: 'lot-state.retend',
  DIVIDING_PRICE: 'lot-state.dividing-price',
  WINNER: 'lot-state.winner',
  CLOSED: 'lot-state.closed',
  CANCELLED: 'lot-state.cancelled'
},
{
  PARTICIPANT: [
    'WAITING_FOR_REQUESTS',
    'WAITING_FOR_OPENING_PROTOCOL',
    'PROCESSING_REQUESTS',
    'ESTIMATING_REQUESTS',
    'CREATING_RETEND',
    'WAITING_FOR_RETEND',
    'WAITING_FOR_RESOLUTION',
    'PROCESSING_RETEND',
    'RETEND',
    'DIVIDING_PRICE',
    'WINNER',
    'CLOSED',
    'CANCELLED'
  ]
});

export default LotState;
